import React from 'react';

import Logo from '@npoed/frontend-theme/dist/assets/images/openedu-logo.png';
import { getConfig } from '@edx/frontend-platform';
import PropTypes from 'prop-types';
import { LinkedLogo } from '../../Logo';

const HeaderLogo = ({
  className,
}) => {
  const config = getConfig();
  return (
    <LinkedLogo
      className={className}
      src={Logo}
      href={config.PLP_BASE_URL}
      alt={config.SITE_NAME}
    />
  );
};

HeaderLogo.propTypes = {
  className: PropTypes.string,
};

HeaderLogo.defaultProps = {
  className: undefined,
};

export default HeaderLogo;
